import React from 'react';
import { arrayOf, shape } from 'prop-types';
import PageHeader from 'components/PageHeader';
import DebugBundleItem from 'components/DebugBundleItem';

const ITEM_COMPONENTS = {
  header: PageHeader
};

function SprinkleBundle(props) {
  const { items } = props;

  return items.map(item => {
    const { id, type, data } = item;

    const Component = ITEM_COMPONENTS[type] || DebugBundleItem;

    return <Component key={id} {...data} />;
  });
}

SprinkleBundle.propTypes = {
  items: arrayOf(
    shape({
      // CLEANUP: item
    })
  )
};

SprinkleBundle.defaultProps = {
  items: []
};

export default SprinkleBundle;
